import styled from 'styled-components';

const ViewContainer = styled.div<{
  lockMap: boolean;
}>`
  position: relative;
  height: 100%;
  width: 100%;

  ${(props) => props.lockMap && 'pointer-events:none;'}

  .overlayMap {
    position: absolute;
    top: 20px;
    height: 100%;
    width: calc(100% - 40px);
    z-index: 3;
    pointer-events: none;
    padding: 20px;

    @media (min-width: 845px) {
      margin-top: -20px;
    }

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      top: 0;
      left: auto;
      z-index: 4;
      padding: 16px;
      width: calc(100% - 32px);
    }
  }

  .overlayHeader {
    width: calc(100% - 80px);
    display: flex;
    flex-direction: row;
    align-items: center;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
    }
  }

  .overlayTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 20px;
    color: #f4501c;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      font-size: 16px;
    }
  }

  .overlaySubTitleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: -10px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: -5px;
    }
  }

  .overlaySubtitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 30px;
    margin-top: 14px;
    text-transform: uppercase;
    color: #233545;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-top: 20px;
      font-size: 18px;
    }
  }

  .overlaySelectContainer {
    width: 400px;
    margin-left: 8px;
    pointer-events: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: uppercase;
    gap: 16px;
    margin-top: 14px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-left: 0;
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      margin-top: 0;
    }
  }

  .buttonHeaderContainer {
    margin-left: auto;
    pointer-events: auto;
  }

  .infoContainer {
    margin-top: 20px;
    width: 380px;
    height: 67vh;
    background-color: transparent;
    border-radius: 4px;
    z-index: 9;
    position: relative;
    pointer-events: all;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 100%;
      margin-top: 50vh;
    }
  }

  .whiteShadow {
    position: absolute;
    top: 0;
    left: 0;
    height: 223px;
    width: 100%;
    background-image: linear-gradient(to bottom, #fafafa, transparent);
    pointer-events: none;
  }

  .hotelIconContainer {
    width: 40px;
    height: 40px;
    color: white;
    font-size: 28px;
    border-radius: 50%;
    background-color: #1f2b37;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .iconHotelTriangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 16px 16px 0 16px;
    margin-left: 4px;
    margin-top: -8px;
    border-color: #1f2b37 transparent transparent transparent;
  }

  .hotelMarker:hover {
    cursor: pointer;
  }

  .mapboxgl-ctrl-bottom-right {
    display: none !important;
  }

  .mapboxgl-ctrl-logo {
    display: none !important;
  }

  .lockMapContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    margin-top: 8px;
    pointer-events: all;

    @media (min-width: 1000px) {
      display: none;
    }

    @media (max-width: 845px) {
      margin-top: 0;
    }
  }

  .lockMapContainer p {
    margin-left: 10px;
  }

  .navigationContainer {
    position: absolute;
    right: 20px;
    bottom: 10vh;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      right: 16px;
      bottom: 15vh;
    }
  }

  .dateReportText {
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.oswald};
    margin-top: 15px;
    margin-bottom: -5px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-left: 10px;
    }
  }

  .button-display-pos {
    color: #233545;
    background: #0000001c;
    font-size: 15px;
  }
`;

export default ViewContainer;
